<script lang="ts">
    export let small: boolean = false;
    export let big: boolean = false;
    export let max: string = "1100px";
    export let padding: string = "1em";
</script>

<div class="container" class:small class:big style="--max: {max}; --padding: {padding}">
    <slot />
</div>

<style lang="scss">
    @import "./src/vars";

    .container {
        position: relative;
        z-index: 1;
        margin: auto;
        max-width: var(--max);
        width: 100%;
        padding: var(--padding) 1em;
        &.small {
            max-width: 800px;
        }
        &.big {
            max-width: 1500px;
        }
    }
</style>
